/** Where users land after clicking verify / reset links (must be in Firebase Authorized domains). */
const PRODUCTION_CONTINUE_URL = 'https://theoberois.com';

export function getAuthActionCodeSettings() {
  const fromEnv = (process.env.REACT_APP_AUTH_CONTINUE_URL || '').trim();
  if (fromEnv) {
    return { url: fromEnv, handleCodeInApp: false };
  }
  // Production builds must never redirect to localhost from a deployed email link
  if (process.env.NODE_ENV === 'production') {
    return { url: PRODUCTION_CONTINUE_URL, handleCodeInApp: false };
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return { url: window.location.origin, handleCodeInApp: false };
  }
  return { url: PRODUCTION_CONTINUE_URL, handleCodeInApp: false };
}

export function isCustomAuthEmailEnabled() {
  return process.env.REACT_APP_USE_CUSTOM_AUTH_EMAIL === 'true';
}

/** Shown in UI when using Resend custom domain */
export function getAuthEmailFromLabel() {
  return process.env.REACT_APP_EMAIL_FROM_LABEL || 'verify@theoberois.com';
}
